export const LogoMark = ({ className = "w-10 h-10" }) => (
  <img src="/logo-amt.webp" alt="Augusto Maciel Team" className={`${className} rounded-full bg-white object-contain ring-2 ring-white/20 shrink-0`} data-testid="brand-logo-img" />
);

export const Logo = ({ dark = true, compact = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark className={compact ? "w-10 h-10" : "w-14 h-14"} />
    {!compact && (
      <div className="leading-none">
        <div className={`font-display text-xl font-extrabold tracking-wide ${dark ? "text-white" : "text-zinc-900"}`}>AUGUSTO MACIEL</div>
        <div className="font-display text-[11px] font-bold tracking-[0.45em] text-red-600">TEAM · JIU-JITSU</div>
      </div>
    )}
  </div>
);
